import { MdClose } from 'react-icons/md'

import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { setPosponeInformationBanner } from '@/libs/store/slice/ui-slice'

export default function InformationBanner({ informationBanner }: { informationBanner: string }) {
  const currentDate = new Date()
  const dispatch = useAppDispatch()

  const handleDismiss = () => {
    const postponeOneHour = new Date(currentDate.getTime() + 60 * 60 * 1000)

    dispatch(setPosponeInformationBanner(postponeOneHour))
  }

  return (
    <div className=' flex flex-col gap-1 rounded-2xl bg-neutral-grey-100 px-4 py-3'>
      <div className='flex items-center justify-between'>
        <span className='text-xs font-bold'>Notice:</span>
        <MdClose className='h-5 w-5 cursor-pointer text-neutral-grey-600' onClick={handleDismiss} />
      </div>
      <p className='text-xs font-normal text-neutral-grey-800'>{informationBanner}</p>
    </div>
  )
}
